module.exports = __webpack_public_path__ + "static/media/mk.b96b8a63.svg";